import React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, TextField, Input, CircularProgress, Snackbar } from '@material-ui/core';
import Parse from 'parse';
import { Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DeleteOutlineOutlined from '@material-ui/icons/DeleteOutlineOutlined';
import Alert from '@material-ui/lab/Alert';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from "moment"
import OrderSavedSuccessfylly from './orderSavedSuccessfully.png'
import OrderSavedMaturity from './2.png'
import { getFromAPI } from '../helpers/sqlApiCalls';
import ModalConfirm from './ModalConfirm';

class NewOrder extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            products: null,
            // priceList: null,
            stock: [],
            priceList: [],
            loadingArts: true
        }
        this.stockloaded = false
        this.plloaded = false
        this.clData = JSON.parse(localStorage.clData)
        this.defaultConfig = JSON.parse(localStorage.defaultConfig)
        this.stock = []
        this.arrStockArticles = [];
    }

    getMonday = () => {
        let d = new Date();
        var day = d.getDay(),
            diff = d.getDate() - day;
        return new Date(d.setDate(diff)).setHours(0, 0, 0, 0);
    }
    _newcalc = (x, y, plb, pls, clt, clb, cls) => {
        var multiplemoney = 1
        /* TODO changesStructure */
        if (global.multiplemoney && global.codemoney) {
            var fecha = this.getMonday()
            var diferencia = 10000000000000000
            for (var i in this.moneys) {
                var mon = this.moneys[i]
                if (Math.abs(fecha - new Date(mon.t).setHours(0, 0, 0, 0)) < diferencia) {
                    diferencia = Math.abs(fecha - mon.t)
                    multiplemoney = mon.v
                }
            }
        }

        const arr0 = [],
            arr1 = [],
            arr2 = [],
            arr3 = [];
        const plbonus = plb
        for (const i in plbonus) {
            switch (plbonus[i].t) {
                case 0:
                    arr0.push({ "o": plbonus[i], "a": 0 })
                    break;
                case 1:
                    arr1.push({ "o": plbonus[i], "a": 0 })
                    break;
                case 2:
                    arr2.push({ "o": plbonus[i], "a": 0 })
                    break;
                case 3:
                    arr2.push({ "o": plbonus[i], "a": 0 })
                    break;
                default:
                    break;
            }
        }
        const plsurcharge = pls
        for (const i in plsurcharge) {
            switch (plsurcharge[i].t) {
                case 0:
                    arr0.push({ "o": plsurcharge[i], "a": 1 })
                    break;
                case 1:
                    arr1.push({ "o": plsurcharge[i], "a": 1 })
                    break;
                case 2:
                    arr2.push({ "o": plsurcharge[i], "a": 1 })
                    break;
                case 3:
                    arr3.push({ "o": plsurcharge[i], "a": 1 })
                    break;
                default:
                    break;
            }
        }
        const cltaxes = clt
        for (const i in cltaxes) {
            switch (cltaxes[i].t) {
                case 0:
                    arr0.push({ "o": cltaxes[i], "a": 2 })
                    break;
                case 1:
                    arr1.push({ "o": cltaxes[i], "a": 2 })
                    break;
                case 2:
                    arr2.push({ "o": cltaxes[i], "a": 2 })
                    break;
                case 3:
                    arr3.push({ "o": cltaxes[i], "a": 2 })
                    break;
                default:
                    break;
            }
        }
        const clbonus = clb
        for (const i in clbonus) {
            switch (clbonus[i].t) {
                case 0:
                    arr0.push({ "o": clbonus[i], "a": 0 })
                    break;
                case 1:
                    arr1.push({ "o": clbonus[i], "a": 0 })
                    break;
                case 2:
                    arr2.push({ "o": clbonus[i], "a": 0 })
                    break;
                case 3:
                    arr3.push({ "o": clbonus[i], "a": 0 })
                    break;
                default:
                    break;

            }
        }
        const clsurcharge = cls
        for (const i in clsurcharge) {
            switch (clsurcharge[i].t) {
                case 0:
                    arr0.push({ "o": clsurcharge[i], "a": 1 })
                    break;
                case 1:
                    arr1.push({ "o": clsurcharge[i], "a": 1 })
                    break;
                case 2:
                    arr2.push({ "o": clsurcharge[i], "a": 1 })
                    break;
                case 3:
                    arr3.push({ "o": clsurcharge[i], "a": 1 })
                    break;
                default:
                    break;
            }
        }
        const artTaxes = x.tx
        for (const i in artTaxes) {
            switch (artTaxes[i].t) {
                case 0:
                    arr0.push({ "o": artTaxes[i], "a": 2 })
                    break;
                case 1:
                    arr1.push({ "o": artTaxes[i], "a": 2 })
                    break;
                case 2:
                    arr2.push({ "o": artTaxes[i], "a": 2 })
                    break;
                case 3:
                    arr3.push({ "o": artTaxes[i], "a": 2 })
                    break;
                default:
                    break;
            }
        }
        const artBonus = x.b
        for (const i in artBonus) {
            arr1.push({ "o": artBonus[i], "a": 0 })
        }
        if (y && y.fp && y.fp.f) {
            var _fp = (+y.fp.a) * x.um[x.dum].e * multiplemoney

            for (var _i_ in arr3) {

                const nn = this._operation(arr3[_i_], _fp)
                switch (arr3[_i_].a) {
                    case 0:
                        _fp -= +nn
                        break;
                    case 1:
                        _fp += +nn
                        break;
                    case 2:
                        _fp += +nn
                        break;
                    default:
                        break;
                }

            }

            return (_fp)
        }


        const nc = parseFloat(x.nc);
        const ncu = (y && y.u) ? ((y.u.f) ? (+parseFloat(x.nc)) + (+y.u.a) : (+parseFloat(x.nc)) + (+parseFloat(x.nc)) * (+y.u.a) / 100) : nc
        let v0 = 0;
        let v1 = 0;
        let v2 = 0;
        if (x.v) {
            v1 += this._operation({ o: x.v }, ncu)
        }
        for (let _i_ in arr0) {
            const nn = this._operation(arr0[_i_], nc)
            switch (arr0[_i_].a) {
                case 0:
                    v0 -= +nn
                    break;
                case 1:
                    v0 += +nn
                    break;
                case 2:
                    v0 += +nn
                    break;
                default:
                    break;
            }
        }

        for (let _i_ in arr1) {
            const nn = this._operation(arr1[_i_], ncu)
            if (nn) {
                switch (arr1[_i_].a) {
                    case 0:
                        v1 -= +nn
                        break;
                    case 1:
                        v1 += +nn
                        break;
                    case 2:
                        v1 += +nn
                        break;
                    default:
                        break;
                }
            }
        }
        v2 = +v1 + (+v0) + (+ncu)
        for (let _i_ in arr2) {
            const nn = this._operation(arr2[_i_], v2)
            switch (arr2[_i_].a) {
                case 0:
                    v2 -= +nn
                    break;
                case 1:
                    v2 += +nn
                    break;
                case 2:
                    v2 += +nn
                    break;
                default:
                    break;
            }
        }
        return v2 * x.um[x.dum].e
    }

    _operation = (x, y) => {
        if (x.o.f) {
            return +x.o.a
        }
        else {
            return +x.o.a * y / 100
        }
    }

    getArts() {
        this.setState({ products: JSON.parse(localStorage.articulos) })
    }

    async getData() {

        /************************ STOCK ********************* */
        const stock = await getFromAPI("Stock", `d=${this.clData.de ? this.clData.de : this.defaultConfig.defaultDeposit}`)
        let stockObject = {};
        let arrStock = [];
        for (let element of stock) {

            stockObject[element.a] = {
                k: element.k,
                a: element.a,
                d: element.d,
                q: element.q,
            }
            arrStock.push(element.a)
        }
        this.stock = stockObject;
        this.arrStockArticles = arrStock
        // localStorage.stock = JSON.stringify({ arrS: stockObject, arrStockArticles: arrStock })
        this.setState({ stock: stockObject })

        /************************ PRICE LIST ********************* */
        const pl = await getFromAPI("PriceList", `k=${this.clData.pl ? this.clData.pl : '1'}`)

        this.priceList = pl[0];
        let articlesOnPl = pl[0].a
        let articlesKeysArray = [];
        for (let i in articlesOnPl) {
            articlesKeysArray.push(articlesOnPl[i].k)
        };
        // localStorage.priceList = JSON.stringify({ priceList: pl[0], statepriceList: articlesKeysArray })
        this.setState({ priceList: articlesKeysArray })

        /************************ ARTICLES ********************* */
        const articles = await getFromAPI("Articles")

        let arts = {}

        for (let article of articles) {
            var algo = JSON.parse(JSON.stringify(article));
            // TODO: changestructure back surcharge bonus and tax from clients for newcalc
            if (this.priceList.a[algo.k]) {
                let price = this._newcalc(algo, this.priceList.a[algo.k], this.priceList.b, this.priceList.su, null, null, null)
                let stockcolor = "#FF3737"
                const stockart = this.stock[algo.k]
                if (stockart && stockart.q > 20) {
                    stockcolor = "#91DD60"
                }
                else if (
                    stockart && stockart.q > 0
                ) {
                    stockcolor = "#F7941E"
                }
                algo.pld = this.priceList.a[algo.k]
                algo.plk = this.priceList.k
                algo.stock = stockcolor;
                algo.stock2 = stockart;
                algo.price = price;
                arts[algo.k] = algo;
            }
        }
        // localStorage.articulos = JSON.stringify(arts)
        this.setState({ products: arts })
    }

    setPL(x) {
        this.getArts(x)
    }

    getPL() {
        const data = JSON.parse(localStorage.priceList)
        this.priceList = data.priceList
        this.setState({ priceList: data })
        this.setPL(data.statepriceList);
    }

    async componentDidMount() {
        await this.getData()
        this.setState({ loadingArts: false })
    }

    render() {
        return (
            <MakeOrder changeView2={(x, y) => { this.props.changeView2(x, y) }} changeView={(x, y, z) => { this.setState({ actualView: 2, selectedOrder: { sk: x, te: y, st: z } }) }} products={this.state.products} loadingArts={this.state.loadingArts}></MakeOrder>
        )
    }
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            //   display: 'flex',
            //   flexWrap: 'wrap',
            //   '& > *': {
            //     margin: theme.spacing(1),
            //   },
        },
        paper: {
            position: "relative",
            minHeight: '25vh',
            paddingTop: theme.spacing(1),
            paddingLeft: 10,
            paddingRight: 10,
        },
        textField: {
            width: '100%'
        },
        red: {
            color: '#f44336'
        }
    }),
);

function MakeOrder(props) {

    const classes = useStyles();

    var timeout = null
    var tezto = null

    const defaultConfig = JSON.parse(localStorage.defaultConfig)

    const [cart, addTocart] = React.useState(localStorage.cart && localStorage.cart.length > 0 ? JSON.parse(localStorage.cart) : {});
    const [text, refreshText] = React.useState('');
    const [filterProduct, refreshFilter] = React.useState({});
    const [openEndOrder, setOpenEndOrder] = React.useState(false);
    const [expiredCCA, setExpiert] = React.useState(0);


    const handleClickOpenEndOrder = async () => {
        let Orders = Parse.Object.extend("Orders");
        let orders = new Orders();
        const tim = Date.now()
        const clin = JSON.parse(localStorage.clInfo)
        const obj = {
            or: 2,
            //p: { c: { la: 0, lo: 0 } },
            f: true,
            envId: localStorage.envId,
            c: clin,
            te: tim,
            t: tim,
            cfost: localStorage.client + 'true' + '1' + localStorage.sellerCode + (tim).toString(),
            se: localStorage.sellerCode,
            ts: tim,
            gb: 0,
            s: 1,
            sk: localStorage.sellerCode + "" + (localStorage.client) + moment(tim).format('YYMMDDhhmmss'),
        }
        const o = {}
        const tt = { to: 0, t: 0, tn: 0 }
        for (var i in cart) {
            const elem = cart[i][1]

            if (!elem.stock2 || elem.stock2.q <= 0) {
                setOpen(true);
                seterr('No puedes agregar un producto sin stock')
                return

            }

            elem.q = elem.quantity
            elem.u = elem.price * (+localStorage.currencyValue)
            elem.s = elem.price * (+localStorage.currencyValue)
            elem.t = (elem.total ? elem.total : elem.price) * (+localStorage.currencyValue)
            tt.to += elem.t
            tt.tn += 0
            tt.t += elem.t
            elem.b = 0
            o[elem.k] = elem

        }
        obj.o = o
        obj.tt = tt

        const salesCondition = await getFromAPI("SalesCondition", `k=${clin.sc}`)


        if (salesCondition && salesCondition.length) obj.sc = {
            'k': salesCondition[0].k,
            'n': salesCondition[0].n
        }

        setExpiert(localStorage.atraso)


        let monto = (defaultConfig.pedidoMinimob2b && defaultConfig.pedidoMinimob2b !== null) ? defaultConfig.pedidoMinimob2b : null
        const total = obj.tt.t

        if (monto !== null) {

            if (total < (monto * (+localStorage.currencyValue))) {

                setOpen(true);
                seterr(`No es posible realizar un pedido por un monto menor a USD ${monto}`)
                return
            }

        }

        // localStorage.historialPedidos=""
        //   setOpenEndOrder(true);

        orders.save(obj).then((order) => {
            localStorage.historialPedidos = ""
            setOpen(false)
            setOpenEndOrder(true);
            localStorage.cart = JSON.stringify({})
            addTocart({})
            refreshText({})
            refreshFilter({})
        })
    };

    const handleCloseEndOrder = () => {
        setOpenEndOrder(false);
        props.changeView2(null, 1)
    };

    // const handleCloseEndOrder1 = () => {
    //     setOpenEndOrder(false);
    //     // props.changeView3(null,1,ordersaved)
    // };

    const handleCloseEndOrder2 = () => {
        setOpenEndOrder(false);

    };

    // const handleCloseEndOrder3 = () => {
    //     setOpenEndOrder(false);
    // };


    const fiilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        clearTimeout(timeout)
        tezto = event.target.value
        timeout = setTimeout(function () {
            filter();
        }, 500)
        refreshText(event.target.value)

    }

    const filter = (_texto) => {
        _texto = tezto
        var encontro = false
        var splited = _texto.split(" ")
        for (var i in splited) {
            if (splited[i].length > 2) {
                encontro = true
            }
        }
        if (encontro) {
            if (encontro) {
                const texto = _texto.toLowerCase()
                const alldata =
                    [...(props.products ? Object.entries(props.products) : [])]
                const newData = alldata.filter((item) => {

                    const filterProd = JSON.parse(JSON.stringify(item))
                    if (filterProd[1] && filterProd[1].v) {
                        delete filterProd[1].v

                    }
                    if (filterProd[1] && filterProd.t) {
                        delete filterProd[1].t
                    }
                    if (filterProd[1] && filterProd.envId) {
                        delete filterProd[1].envId
                    }
                    if (filterProd[1] && filterProd.pk) {
                        delete filterProd[1].pk
                    }
                    if (filterProd[1] && filterProd.um) {
                        delete filterProd[1].um
                    }
                    var contains = true
                    var texto2 = texto.split(' ')
                    for (var ij in texto2) {
                        if (JSON.stringify(filterProd).toLowerCase().indexOf(texto2[ij]) === -1) {
                            contains = false
                        }
                    }
                    if (filterProd &&
                        (contains)
                    ) {
                        return true
                    }
                    else {
                        return false
                    }

                })
                refreshText(_texto)
                refreshFilter(newData)
            }
            else {
                refreshText(_texto)
                refreshFilter({})

            }
        } else {
            refreshText(_texto)
            refreshFilter({})
        }
    }

    const getTotal = () => {
        // for (let i in cart)
        var totalcart = 0
        for (let i in cart) {
            totalcart += (cart[i][1].total ? cart[i][1].total : +cart[i][1].price)
        }
        return (totalcart)
    }

    const [errmessage, seterr] = React.useState("");
    const [open, setOpen] = React.useState(false);

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const [openModal, setOpenModal] = React.useState(false);

    return (
        <div className={classes.root}>
            <Snackbar open={open} autoHideDuration={1700} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    {errmessage}
                </Alert>
            </Snackbar>
            <Dialog
                open={openEndOrder}
                onClose={handleCloseEndOrder}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="divFinish"
                style={{ textAlign: "center", alignItems: "center" }}
            >
                {
                    expiredCCA > 0 ?
                        <img src={OrderSavedMaturity} style={{ width: 150, paddingTop: 20 }} alt="Logo" />
                        :
                        <img src={OrderSavedSuccessfylly} style={{ width: 150, paddingTop: 20 }} alt="Logo" />
                }
                {/* <img src={OrderSavedSuccessfylly} style={{  width: 150,paddingTop:20 }} alt="Logo" /> */}
                <DialogTitle id="alert-dialog-title">{"¡Muchas gracias!"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Recibimos tu pedido{
                            expiredCCA < 1 && " correctamente"}.
                    </DialogContentText>
                    {
                        expiredCCA > 0 &&
                        <DialogContentText id="alert-dialog-description">
                            Recuerda que para que sea procesado debe tener la cuenta corriente regularizada!
                        </DialogContentText>
                    }
                    <Button onClick={handleCloseEndOrder2} contained color="secondary" >
                        Continuar comprando
                    </Button>
                    <Button onClick={handleCloseEndOrder} contained color="secondary" >
                        Ir al inicio
                    </Button>
                </DialogContent>
                <DialogActions>

                </DialogActions>
            </Dialog>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={5}>
                    <Paper className={classes.paper}>
                        <Typography variant="button" component="subtitle2">Buscador</Typography>
                        <Paper elevation={0}>
                            {props.loadingArts ?
                                <div style={{ width: '100%', paddingTop: 20, textAlign: "center" }}>
                                    <Typography>Estamos buscando los mejores precios para usted.</Typography>
                                    <CircularProgress style={{ marginTop: 10, marginBottom: 10 }} color="secondary" />
                                </div>
                                : <TextField
                                    label="Buscar"
                                    id="outlined-margin-dense"
                                    //defaultValue="Default Value"
                                    onChange={fiilter}
                                    color="secondary"
                                    className={classes.textField}
                                    placeholder="Buscar por nombre, código, descripción, categoría"
                                    margin="dense"
                                    variant="outlined"
                                />}
                        </Paper>
                        <List style={{
                            overflow: 'auto',
                            maxHeight: '50vh',
                        }}>
                            {(Object.entries(filterProduct ? filterProduct : {})).map((item2, b) => {
                                const item = Object.entries(item2[1])[1]
                                const itemk = Object.entries(item2[1])[0][1]
                                item[1].quantity = 1
                                return (
                                    <ListItem onClick={() => {
                                        // if (item[1].stock2 && item[1].stock2.q > 0) {
                                        addTocart({ ...cart, [itemk]: item })
                                        localStorage.cart = JSON.stringify({ ...cart, [itemk]: item })

                                        // }
                                        // else {
                                        //     setOpen(true);
                                        //     seterr('No puedes agregar un producto sin stock')
                                        // }
                                    }} >
                                        <div style={{ height: 8, width: 8, borderRadius: 4, backgroundColor: (item[1] ? (item[1].stock) : "red"), marginRight: 10 }}></div>
                                        <ListItemText secondary={`${itemk}`}></ListItemText>
                                        <ListItemText primary={`${item[1] ? (item[1].n) : null} `}></ListItemText>
                                        {/* <ListItemText primary={`$ ${item[1] ? (item[1].price) : null}`}></ListItemText> */}
                                    </ListItem>
                                )
                            })}
                        </List>
                        {!props.loadingArts ?
                            <Grid container spacing={1} >
                                <Grid item xs={4} style={{ textAlign: 'left' }}>
                                    <div style={{ height: 8, width: 8, borderRadius: 4, backgroundColor: '#91DD60', marginRight: 10, display: "inline-block" }}></div>
                                    <Typography style={{ display: "inline-block" }}>Disponible</Typography>
                                </Grid>
                                <Grid item style={{ textAlign: 'center' }} xs={4}>
                                    <div style={{ height: 8, width: 8, borderRadius: 4, backgroundColor: '#F7941E', marginRight: 10, display: "inline-block" }}></div>
                                    <Typography style={{ display: "inline-block" }}>Stock a confirmar</Typography>
                                </Grid>
                                <Grid item style={{ textAlign: 'right', paddingRight: 10 }} xs={4}>
                                    <div style={{ height: 8, width: 8, borderRadius: 4, backgroundColor: '#FF3737', marginRight: 10, display: "inline-block" }}></div>
                                    <Typography style={{ display: "inline-block" }}>No Disponible</Typography>
                                </Grid>
                            </Grid>

                            :
                            null}

                    </Paper>
                </Grid>
                <Grid item xs={12} md={6} lg={7}>
                    <Paper className={classes.paper}>
                        <Typography variant="subtitle2" gutterBottom>Carrito</Typography>
                        {
                            Object.entries(cart ? cart : []).length > 0 &&
                            <Typography style={{ position: "absolute", right: 10, top: 7 }} variant="body2" gutterBottom>(*) Precio sin iva</Typography>

                        }
                        <ul className="todo-list">
                            {Object.entries(cart ? cart : []).map((a, b) => {

                                const article = a[1][1]
                                const haveStock = (article.stock2 && article.stock2.q > 0) ? true : false
                                return (
                                    <li key={b}>
                                        <div className="icon">
                                            <p className={haveStock ? "picon" : `${classes.red} picon`} >{a[0]}</p>
                                        </div>
                                        <div className="name">
                                            <span className={haveStock ? "item-name" : `${classes.red} item-name`}>{article.n}</span>

                                        </div>
                                        <Input
                                            id="standard-number"
                                            placeholder="Cantidad"
                                            style={{ width: 130 }}
                                            defaultValue={article.quantity + ""}
                                            type="number"
                                            disabled={!haveStock}
                                            onChange={(event) => {
                                                const nq = event.target.value
                                                const b = JSON.parse(JSON.stringify(a))
                                                b[1][1].quantity = +nq
                                                b[1][1].total = +nq * (+article.price)
                                                // article.total=nq*article.price
                                                addTocart({ ...cart, [b[0]]: b[1] })
                                                localStorage.cart = JSON.stringify({ ...cart, [b[0]]: b[1] })
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        <div className={haveStock ? "price" : `${classes.red} price`}>
                                            <h3>{`USD ${parseFloat(article.total ? article.total : article.price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`}</h3>
                                        </div>

                                        <DeleteOutlineOutlined secondary className="remove" onClick={() => {
                                            const cart2 = JSON.parse(JSON.stringify(cart))
                                            delete cart2[a[0]]
                                            addTocart(cart2)
                                            localStorage.cart = JSON.stringify(cart2)
                                        }} />
                                    </li>
                                )
                            })}
                        </ul>
                        {Object.entries(cart ? cart : []).length > 0 ?
                            <Grid container className={classes.root} spacing={2}>
                                <Grid alignContent="flex-start" item xs={6} onClick={() => {
                                    addTocart({})
                                    localStorage.cart = JSON.stringify({})

                                }} sm={6} md={4}>
                                    <ListItem style={{ paddingLeft: 0 }}>
                                        <DeleteOutlineOutlined className="removeCart" />
                                        <Typography className="removeCart">Vaciar carrito</Typography>
                                    </ListItem>
                                </Grid>
                                <Grid item xs={6} sm={6} md={4}>
                                    <ListItem>
                                        <Typography>Total: $ {parseFloat(getTotal()).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}  {'*'}</Typography>
                                    </ListItem>
                                </Grid>
                                <Grid style={{ paddingRight: 30, textAlign: "right" }} item xs={12} md={4}>
                                    <Button style={{ borderRadius: 22 }} onClick={() => setOpenModal(true)} variant="contained" color="secondary">
                                        Finalizar Pedido
                                    </Button>
                                </Grid>
                            </Grid>
                            :
                            null
                        }
                    </Paper>
                </Grid>
            </Grid>
            {openModal ?
                <ModalConfirm open={Boolean(openModal)} setOpen={setOpenModal} cart={cart} confirm={handleClickOpenEndOrder} />
                : null
            }
        </div >
    )
}

// function renderRow(props: ListChildComponentProps) {
//     const { data, index, style } = props;
//     const item = data[index];

//     return (
//         <ListItem button style={{ textAlign: "left" }} key={index}>
//             <div style={{ height: 8, width: 8, borderRadius: 4, backgroundColor: (item[1] ? (item[1].stock) : "red"), marginRight: 10 }}></div>
//             <ListItemText primary={`${item[0]} `}></ListItemText>
//             <ListItemText primary={`${item[1] ? (item[1].n) : null} `}></ListItemText>
//             <ListItemText primary={`$ ${item[1] ? (item[1].price) : null}`}></ListItemText>
//             <ListItemText primary={` ${item[1] ? (item[1].stock2.q) : null}`}></ListItemText>
//         </ListItem>
//     );
// }
export default NewOrder;